
export function closeApp() {
    // TODO: we need to discuss this
    window.dolphinApp ? window.dolphinApp.close() : alert("app to be closed");
    // OR fire intent to go to another activity
}



// WEBPACK FOOTER //
// ./src/bridge/utils.js